export class Preferences {

  public store(key: string, val: unknown) {
    localStorage.setItem(key, JSON.stringify(val));
  }

  public retrieve<T>(key: string, defaultVal: T): T {

    const ret = localStorage.getItem(key);

    if(ret === null) {
      return defaultVal;
    }

    let parsed: T | undefined;
    try {
      parsed = JSON.parse(ret);
    } catch {
      // nothing to do
    }

    return parsed !== undefined ? parsed : defaultVal;
  }

}

export const curPref = new Preferences();
